import { useMemo } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { RoutingPaths } from 'app/routes/routes'

import userStore from 'entities/user/module/user-store'

import { ProfileTypes } from 'shared/constants'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { BlockArrows } from 'shared/ui/block-arrows'

const getDocumentPath = (
  hasDocument: boolean,
  profileTypeKey: string,
): string => {
  return hasDocument
    ? RoutingPaths.profile.view.path(profileTypeKey)
    : RoutingPaths.profile.edit.path(profileTypeKey)
}

export const DocumentsSection = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { account } = userStore

  const hasPassport = !!account?.id_card
  const hasIntPassport = !!account?.international_passport

  const passportPath = useMemo(
    () => getDocumentPath(hasPassport, ProfileTypes.PASS.key),
    [hasPassport],
  )

  const intPassportPath = useMemo(
    () => getDocumentPath(hasIntPassport, ProfileTypes.INT.key),
    [hasIntPassport],
  )

  const handleClick = (key: string) => {
    if (key === 'passport') {
      navigate(passportPath)
    } else if (key === 'int_passport') {
      navigate(intPassportPath)
    }
  }

  const listContent = [
    {
      key: 'passport',
      name: t('passport_title'),
      icon: (
        <AppIcon
          id={AllIcons.ID_CARD_2}
          height={24}
          width={24}
          color="var(--link)"
        />
      ),
    },
    {
      key: 'int_passport',
      name: t('passport'),
      icon: (
        <AppIcon
          id={AllIcons.PASSPORT}
          height={24}
          width={24}
          color="var(--link)"
        />
      ),
    },
  ]

  return (
    <BlockArrows
      title={t('documents')}
      listContent={listContent}
      onClick={handleClick}
    />
  )
}
